export default "__VITE_ASSET__BMRO4ktv__"